var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEllipsesTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 151,
    viewBox: "0 0 198 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.428 -0.0871429C289.428 82.9673 224.966 150.253 145.5 150.253C66.0342 150.253 1.57242 82.9673 1.57242 -0.0871429C1.57242 -83.1416 66.0342 -150.428 145.5 -150.428C224.966 -150.428 289.428 -83.1416 289.428 -0.0871429Z",
    stroke: "#047EFF",
    strokeWidth: 1.14484
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.503 150.616C225.196 150.616 289.799 83.1454 289.799 -0.083725C289.799 -83.3129 225.196 -150.783 145.503 -150.783C65.8107 -150.783 1.20728 -83.3129 1.20728 -0.083725C1.20728 83.1454 65.8107 150.616 145.503 150.616Z",
    stroke: "#047EFF",
    strokeWidth: 0.572418
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.264 -0.0918121C281.264 78.2537 220.457 141.722 145.5 141.722C70.5431 141.722 9.73648 78.2537 9.73648 -0.0918121C9.73648 -78.4374 70.5431 -141.906 145.5 -141.906C220.457 -141.906 281.264 -78.4374 281.264 -0.0918121Z",
    stroke: "#047EFF",
    strokeWidth: 1.14484
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.503 142.086C220.686 142.086 281.635 78.4328 281.635 -0.0874329C281.635 -78.6077 220.686 -142.261 145.503 -142.261C70.319 -142.261 9.37061 -78.6077 9.37061 -0.0874329C9.37061 78.4328 70.319 142.086 145.503 142.086Z",
    stroke: "#047EFF",
    strokeWidth: 0.572418
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.101 -0.089859C273.101 73.5468 215.949 133.198 145.501 133.198C75.0526 133.198 17.901 73.5468 17.901 -0.089859C17.901 -73.7266 75.0526 -133.378 145.501 -133.378C215.949 -133.378 273.101 -73.7266 273.101 -0.089859Z",
    stroke: "#047EFF",
    strokeWidth: 1.14484
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.504 133.561C216.179 133.561 273.472 73.7247 273.472 -0.0867157C273.472 -73.8981 216.179 -133.734 145.504 -133.734C74.829 -133.734 17.5356 -73.8981 17.5356 -0.0867157C17.5356 73.7247 74.829 133.561 145.504 133.561Z",
    stroke: "#047EFF",
    strokeWidth: 0.572418
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.933 -0.0845566C264.933 68.8432 211.436 124.677 145.497 124.677C79.5572 124.677 26.0607 68.8432 26.0607 -0.0845566C26.0607 -69.0124 79.5572 -124.847 145.497 -124.847C211.436 -124.847 264.933 -69.0124 264.933 -0.0845566Z",
    stroke: "#047EFF",
    strokeWidth: 1.14484
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.499 125.039C211.665 125.039 265.303 69.02 265.303 -0.0825882C265.303 -69.1852 211.665 -125.204 145.499 -125.204C79.3326 -125.204 25.6943 -69.1852 25.6943 -0.0825882C25.6943 69.02 79.3326 125.039 145.499 125.039Z",
    stroke: "#047EFF",
    strokeWidth: 0.572418
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.769 -0.0901794C256.769 64.1288 206.928 116.146 145.497 116.146C84.0662 116.146 34.2248 64.1288 34.2248 -0.0901794C34.2248 -64.3091 84.0662 -116.326 145.497 -116.326C206.928 -116.326 256.769 -64.3091 256.769 -0.0901794Z",
    stroke: "#047EFF",
    strokeWidth: 1.14484
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.5 116.504C207.157 116.504 257.14 64.3028 257.14 -0.0909348C257.14 -64.4846 207.157 -116.686 145.5 -116.686C83.8425 -116.686 33.8594 -64.4846 33.8594 -0.0909348C33.8594 64.3028 83.8425 116.504 145.5 116.504Z",
    stroke: "#047EFF",
    strokeWidth: 0.572418
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.61 -0.085083C248.61 59.425 202.423 107.625 145.501 107.625C88.5791 107.625 42.3927 59.425 42.3927 -0.085083C42.3927 -59.5952 88.5791 -107.795 145.501 -107.795C202.423 -107.795 248.61 -59.5952 248.61 -0.085083Z",
    stroke: "#047EFF",
    strokeWidth: 1.14484
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.497 107.986C202.646 107.986 248.974 59.6022 248.974 -0.0826416C248.974 -59.7675 202.646 -108.152 145.497 -108.152C88.3484 -108.152 42.0203 -59.7675 42.0203 -0.0826416C42.0203 59.6022 88.3484 107.986 145.497 107.986Z",
    stroke: "#047EFF",
    strokeWidth: 0.572418
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.445 -0.084137C240.445 54.7171 197.914 99.0994 145.501 99.0994C93.0873 99.0994 50.5561 54.7171 50.5561 -0.084137C50.5561 -54.8854 93.0873 -99.2677 145.501 -99.2677C197.914 -99.2677 240.445 -54.8854 240.445 -0.084137Z",
    stroke: "#047EFF",
    strokeWidth: 1.14484
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.5 99.4608C198.139 99.4608 240.812 54.894 240.812 -0.0819626C240.812 -55.0579 198.139 -99.6248 145.5 -99.6248C92.8598 -99.6248 50.1868 -55.0579 50.1868 -0.0819626C50.1868 54.894 92.8598 99.4608 145.5 99.4608Z",
    stroke: "#047EFF",
    strokeWidth: 0.572418
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.282 -0.089035C232.282 50.0033 193.406 90.5684 145.502 90.5684C97.5971 90.5684 58.7209 50.0033 58.7209 -0.089035C58.7209 -50.1814 97.5971 -90.7464 145.502 -90.7464C193.406 -90.7464 232.282 -50.1814 232.282 -0.089035Z",
    stroke: "#047EFF",
    strokeWidth: 1.14484
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.5 90.9305C193.631 90.9305 232.649 50.181 232.649 -0.0861282C232.649 -50.3532 193.631 -91.1028 145.5 -91.1028C97.369 -91.1028 58.3511 -50.3532 58.3511 -0.0861282C58.3511 50.181 97.369 90.9305 145.5 90.9305Z",
    stroke: "#047EFF",
    strokeWidth: 0.572418
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.298 -0.0864487C223.298 44.8262 188.443 81.1922 145.498 81.1922C102.553 81.1922 67.6974 44.8262 67.6974 -0.0864487C67.6974 -44.9991 102.553 -81.3651 145.498 -81.3651C188.443 -81.3651 223.298 -44.9991 223.298 -0.0864487Z",
    stroke: "#047EFF",
    strokeWidth: 1.14484
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.501 81.5536C188.672 81.5536 223.67 45.0031 223.67 -0.0842819C223.67 -45.1716 188.672 -81.7222 145.501 -81.7222C102.329 -81.7222 67.332 -45.1716 67.332 -0.0842819C67.332 45.0031 102.329 81.5536 145.501 81.5536Z",
    stroke: "#047EFF",
    strokeWidth: 0.572418
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.139 -0.0911255C215.139 40.1126 183.938 72.6613 145.502 72.6613C107.066 72.6613 75.8654 40.1126 75.8654 -0.0911255C75.8654 -40.2949 107.066 -72.8436 145.502 -72.8436C183.938 -72.8436 215.139 -40.2949 215.139 -0.0911255Z",
    stroke: "#047EFF",
    strokeWidth: 1.14484
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.502 73.0238C184.164 73.0238 215.506 40.2905 215.506 -0.0879593C215.506 -40.4665 184.164 -73.1997 145.502 -73.1997C106.839 -73.1997 75.4966 -40.4665 75.4966 -0.0879593C75.4966 40.2905 106.839 73.0238 145.502 73.0238Z",
    stroke: "#047EFF",
    strokeWidth: 0.572418
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.975 -0.0860214C206.975 35.4089 179.43 64.1403 145.502 64.1403C111.575 64.1403 84.0294 35.4089 84.0294 -0.0860214C84.0294 -35.5809 111.575 -64.3123 145.502 -64.3123C179.43 -64.3123 206.975 -35.5809 206.975 -0.0860214Z",
    stroke: "#047EFF",
    strokeWidth: 1.14484
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.504 64.4993C179.658 64.4993 207.346 35.5834 207.346 -0.0862808C207.346 -35.7559 179.658 -64.6719 145.504 -64.6719C111.351 -64.6719 83.6633 -35.7559 83.6633 -0.0862808C83.6633 35.5834 111.351 64.4993 145.504 64.4993Z",
    stroke: "#047EFF",
    strokeWidth: 0.572418
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.811 -0.0892143C198.811 30.6968 174.921 55.611 145.502 55.611C116.084 55.611 92.1935 30.6968 92.1935 -0.0892143C92.1935 -30.8753 116.084 -55.7894 145.502 -55.7894C174.921 -55.7894 198.811 -30.8753 198.811 -0.0892143Z",
    stroke: "#047EFF",
    strokeWidth: 1.14484
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.643 -0.0909576C190.643 25.9862 170.408 47.0831 145.498 47.0831C120.588 47.0831 100.353 25.9862 100.353 -0.0909576C100.353 -26.1681 120.588 -47.265 145.498 -47.265C170.408 -47.265 190.643 -26.1681 190.643 -0.0909576Z",
    stroke: "#047EFF",
    strokeWidth: 1.14484
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.476 -0.0853767C182.476 21.2829 165.896 38.5625 145.495 38.5625C125.094 38.5625 108.514 21.2829 108.514 -0.0853767C108.514 -21.4537 125.094 -38.7332 145.495 -38.7332C165.896 -38.7332 182.476 -21.4537 182.476 -0.0853767Z",
    stroke: "#047EFF",
    strokeWidth: 1.14484
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.497 38.9239C166.125 38.9239 182.847 21.4598 182.847 -0.0831985C182.847 -21.6262 166.125 -39.0903 145.497 -39.0903C124.869 -39.0903 108.147 -21.6262 108.147 -0.0831985C108.147 21.4598 124.869 38.9239 145.497 38.9239Z",
    stroke: "#047EFF",
    strokeWidth: 0.572418
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.319 29.5522C161.126 29.5522 173.94 16.1615 173.94 -0.356737C173.94 -16.875 161.126 -30.2656 145.319 -30.2656C129.513 -30.2656 116.699 -16.875 116.699 -0.356737C116.699 16.1615 129.513 29.5522 145.319 29.5522Z",
    stroke: "#047EFF",
    strokeWidth: 0.572418
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.32 24.612C158.516 24.612 169.214 13.4326 169.214 -0.35783C169.214 -14.1483 158.516 -25.3276 145.32 -25.3276C132.123 -25.3276 121.426 -14.1483 121.426 -0.35783C121.426 13.4326 132.123 24.612 145.32 24.612Z",
    stroke: "#047EFF",
    strokeWidth: 0.572418
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.321 19.6733C155.907 19.6733 164.488 10.7052 164.488 -0.357462C164.488 -11.4201 155.907 -20.3882 145.321 -20.3882C134.735 -20.3882 126.153 -11.4201 126.153 -0.357462C126.153 10.7052 134.735 19.6733 145.321 19.6733Z",
    stroke: "#047EFF",
    strokeWidth: 0.572418
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsesTop);
export default __webpack_public_path__ + "static/media/ellipses-top.dc9677e595569ff1744ea49e04d5f735.svg";
export { ForwardRef as ReactComponent };